export function tenantTypeCategory(t) {
    switch (t) {
        case 'PROCURADORIA_FEDERAL':
        case 'PROCURADORIA_ESTADUAL':
        case 'PROCURADORIA_MUNICIPAL':
            return 'PROCURADORIA';
        case 'DEFENSORIA':
            return 'DEFENSORIA';
        case 'ADVOCACIA_PUBLICA_AUTARQUICA':
            return 'AUTARQUICA';
        case 'ESCRITORIO_PRIVADO':
            return 'ESCRITORIO';
    }
}
export function tenantTypeLabel(t) {
    switch (t) {
        case 'PROCURADORIA_FEDERAL':
            return 'Procuradoria';
        case 'PROCURADORIA_ESTADUAL':
            return 'Procuradoria';
        case 'PROCURADORIA_MUNICIPAL':
            return 'Procuradoria';
        case 'DEFENSORIA':
            return 'Defensoria';
        case 'ADVOCACIA_PUBLICA_AUTARQUICA':
            return 'Advocacia Pública';
        case 'ESCRITORIO_PRIVADO':
            return 'Escritório Privado';
    }
}
//# sourceMappingURL=tenant.js.map